import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './components/Login';
import { testSupabaseConnection } from './lib/testConnection';

function App() {
  const { session, loading } = useAuth();
  const [showTimeoutWarning, setShowTimeoutWarning] = useState(false);

  useEffect(() => {
    testSupabaseConnection();
  }, []);

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setShowTimeoutWarning(true);
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-gray-600 mb-4">Loading...</div>
          {showTimeoutWarning && (
            <div className="text-sm text-amber-600 max-w-md">
              <p>This is taking longer than expected.</p>
              <p className="mt-2">Please check your network connection and refresh the page.</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (!session) {
    return <Login />;
  }

  return <Outlet />;
}

export default App;